import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FormattedHTMLMessage, FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIList from 'UIComponents/list/UIList'; // @ts-expect-error Untyped import

import ContentControlWrapper from '../../../components/ContentControlWrapper'; // @ts-expect-error Untyped import

import ContentViewport from '../../../components/ContentViewport';
import { calculateExamDurationSeconds } from '../../../utils/ContentUtils';
import { getHumanizedDuration } from '../../../utils/utils';
import { device } from '../../../constants/StyledComponentConstants';
import { useFullTrack } from '../../tracks';
import { useCallback } from 'react';
import { useStartExam } from '../../exams';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UsageTracker from '../../../utils/UsageTracker';
import { useExamRulesState } from '../examsStores';
import H4 from 'UIComponents/elements/headings/H4';
const BASE_CLASS_NAME = 'exam-rules-screen';
export const DesktopOnlyUIIllustration = styled(UIIllustration).withConfig({
  displayName: "ExamRulesScreen__DesktopOnlyUIIllustration",
  componentId: "sc-17s80es-0"
})(["@media screen and ", "{display:none;}"], device.mobile);

const ExamRulesScreen = ({
  cooldownHourCount = 12,
  trackId
}) => {
  const {
    track
  } = useFullTrack(trackId);
  const {
    setShowExamRules
  } = useExamRulesState();
  const [startExam, {
    startExamLoading,
    startExamError
  }] = useStartExam();
  const requiredCorrectQuestionCount = track && track.exam ? track.exam.passThreshold : 0;
  const questionCount = track && track.exam ? track.exam.length : 0;
  const durationMinutes = track && track.exam ? track.exam.durationMinutes : 0;
  const handleStart = useCallback(() => {
    if (!track || !track.exam) return null;
    return startExam(Number(trackId), track.exam.id, track.exam.language).then(attempt => {
      setShowExamRules(false);
      UsageTracker.track('examInteraction', {
        action: 'start',
        examId: track && track.exam.id,
        examLength: attempt && attempt.questions.length,
        trackId,
        trackName: track && track.name,
        examAttemptId: attempt && attempt.id
      });
    });
  }, [setShowExamRules, startExam, track, trackId]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(ContentViewport, {
      wrapperClassName: `${BASE_CLASS_NAME}__content-viewport`,
      children: [/*#__PURE__*/_jsx(DesktopOnlyUIIllustration, {
        className: `${BASE_CLASS_NAME}__illustration`,
        name: "nps-question",
        width: 150
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'learningCenter.exams.rules.heading'
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(UIList, {
            childClassName: "m-bottom-3",
            className: `${BASE_CLASS_NAME}__list`,
            styled: true,
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: 'learningCenter.exams.rules.questionCount',
              options: {
                questionCount
              }
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: 'learningCenter.exams.rules.duration',
              options: {
                expectedDuration: getHumanizedDuration(calculateExamDurationSeconds(questionCount))
              }
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: 'learningCenter.exams.rules.requiredCorrectQuestionsCount',
              options: {
                requiredCorrectQuestionCount
              }
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: 'learningCenter.exams.rules.cooldownHourDurationCount',
              options: {
                cooldownHourCount
              }
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: 'learningCenter.exams.rules.maximumDuration',
              options: {
                maximumDuration: getHumanizedDuration(durationMinutes, 'minutes')
              }
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: 'learningCenter.exams.rules.warningNoBackNavigation'
            })]
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'learningCenter.exams.rules.footer'
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`,
      children: /*#__PURE__*/_jsx(UILoadingButton, {
        "data-test-id": "exam-start-button",
        failed: !!startExamError,
        loading: startExamLoading,
        onClick: handleStart,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.exams.rules.startExam'
        })
      })
    })]
  });
};

export default ExamRulesScreen;